<div class="sidebar" lines="none" inset *ngIf="activeOperationId">
  <form>
    <ion-item class="headline-item">
      <h3 class="headline"><i class="icon-team"></i> Team Members</h3>
    </ion-item>
    <p class="sidebar-guidance" *ngIf="mode.edit">
      Direct changes happen here. Team Access assignments stay read-only and are edited from Teams.
    </p>
    <fieldset class="operation-team-members">
      <span class="section-label" (click)="toggleOperationManagersAssignedMenu()">
        <span *ngIf="mode.edit || mode.add">Assigned </span>Manager(s)
      </span>
      <ion-list
        class="assigned-manager-list"
        [class.edit]="mode.edit || mode.add"
        inset
        lines="none"
        [class.show]="managerSidebarDropdownOpen"
      >
        <div class="manager-container" *ngFor="let manager of operationManagers; let idx = index">
          <ion-item class="sidebar-listing" id="operation-manager">
            <div
              class="assignment-editor"
              *ngIf="(mode.edit || mode.add) && operationManagers && isDirectAssignment(manager); else managerSpan"
            >
              <div class="assignment-select-shell">
                <ion-select
                  [class.edit]="mode.edit"
                  [value]="manager?.userId"
                  (ionChange)="managerOnSelect($event, idx)"
                  placeholder="Assign Manager"
                >
                  <ion-select-option
                    *ngFor="let user of users"
                    [value]="user.userId"
                    [selected]="user.userId == manager?.userId"
                  >
                    {{ user.userLastName }}, {{ user.userFirstName }}
                  </ion-select-option>
                </ion-select>
                <span *ngIf="!manager?.userId" class="assignment-select-plus" aria-hidden="true"></span>
              </div>
              <div class="assignment-editor-meta" *ngIf="manager?.userId">
                <div class="assignment-pills" *ngIf="getAssignmentSourceLabel(manager) || hasInheritedTeamAccess(manager)">
                  <span class="assignment-source" *ngIf="getAssignmentSourceLabel(manager)">
                    {{ getAssignmentSourceLabel(manager) }}
                  </span>
                  <span class="assignment-lock" *ngIf="hasInheritedTeamAccess(manager)">Team Access still applies</span>
                </div>
                <span class="assignment-detail" *ngIf="hasInheritedTeamAccess(manager) && getAssignmentDetail(manager)">
                  {{ getAssignmentDetail(manager) }}
                </span>
              </div>
            </div>
            <button
              *ngIf="mode.edit && isDirectAssignment(manager) && manager?.userId"
              type="button"
              class="remove-assignment"
              aria-label="Remove direct manager assignment"
              title="Remove direct manager assignment"
              (click)="removeCallRepOrManager('manager', idx, manager.userId)"
            >
              <span class="remove-assignment-icon" aria-hidden="true"></span>
            </button>
            <ng-template #managerSpan>
              <div class="assignment-copy" [class.is-inherited]="isInheritedOnlyAssignment(manager)">
                <span class="operation-manager">
                  <b>{{ manager?.userFirstName }} {{ manager?.userLastName }}</b>
                </span>
                <span class="assignment-detail" *ngIf="getAssignmentDetail(manager)">{{ getAssignmentDetail(manager) }}</span>
                <div class="assignment-pills" *ngIf="getAssignmentSourceLabel(manager)">
                  <span class="assignment-source">{{ getAssignmentSourceLabel(manager) }}</span>
                  <span class="assignment-lock" *ngIf="mode.edit && isInheritedOnlyAssignment(manager)">Edit in Teams</span>
                </div>
              </div>
            </ng-template>
          </ion-item>
        </div>
        <div class="controls">
          <a *ngIf="mode.add || mode.edit" class="add-members" (click)="addAdditionalOperationManager()">+ Manager</a>
        </div>
      </ion-list>
    </fieldset>
    <fieldset class="operation-callreps">
      <ng-container>
        <span class="section-label" (click)="toggleOperationCallRepsAssignedMenu()">
          <span *ngIf="mode.edit || mode.add">Assigned </span>Care Reps
        </span>
        <ion-list
          class="assigned-callrep-list"
          lines="none"
          *ngIf="operationAssignedUsers"
          [class.show]="callRepSidebarDropdownOpen"
          [class.edit]="mode.edit || mode.add"
        >
          <div class="callrep-container" *ngFor="let operationCallRep of operationAssignedUsers; let idx = index">
            <ion-item class="sidebar-listing" id="operationCallRep-{{ idx }}">
              <div
                class="assignment-editor"
                *ngIf="users && (((mode.edit && operationAssignedUsers.length) || mode.add) && isDirectAssignment(operationCallRep)); else memberSpan"
              >
                <div class="assignment-select-shell">
                  <ion-select
                    (ionChange)="callRepOnSelect($event, idx)"
                    [class.edit]="mode.edit"
                    [value]="operationCallRep?.userId"
                    placeholder="Select User"
                  >
                    <ion-select-option
                      *ngFor="let user of users"
                      [value]="user.userId"
                      [selected]="user.userId == operationCallRep.userId"
                    >
                      {{ user.userLastName }}, {{ user.userFirstName }}
                    </ion-select-option>
                  </ion-select>
                  <span *ngIf="!operationCallRep?.userId" class="assignment-select-plus" aria-hidden="true"></span>
                </div>
                <div class="assignment-editor-meta" *ngIf="operationCallRep?.userId">
                  <div
                    class="assignment-pills"
                    *ngIf="getAssignmentSourceLabel(operationCallRep) || hasInheritedTeamAccess(operationCallRep)"
                  >
                    <span class="assignment-source" *ngIf="getAssignmentSourceLabel(operationCallRep)">
                      {{ getAssignmentSourceLabel(operationCallRep) }}
                    </span>
                    <span class="assignment-lock" *ngIf="hasInheritedTeamAccess(operationCallRep)">
                      Team Access still applies
                    </span>
                  </div>
                  <span
                    class="assignment-detail"
                    *ngIf="hasInheritedTeamAccess(operationCallRep) && getAssignmentDetail(operationCallRep)"
                  >
                    {{ getAssignmentDetail(operationCallRep) }}
                  </span>
                </div>
              </div>
              <button
                *ngIf="mode.edit && isDirectAssignment(operationCallRep) && operationCallRep?.userId"
                type="button"
                class="remove-assignment"
                aria-label="Remove direct care rep assignment"
                title="Remove direct care rep assignment"
                (click)="removeCallRepOrManager('callrep', idx, operationCallRep.userId)"
              >
                <span class="remove-assignment-icon" aria-hidden="true"></span>
              </button>
              <ng-template #memberSpan>
                <div class="assignment-copy" [class.is-inherited]="isInheritedOnlyAssignment(operationCallRep)">
                  <span class="operation-callrep">
                    <b>{{ operationCallRep.userFirstName }} {{ operationCallRep.userLastName }}</b>
                  </span>
                  <span class="assignment-detail" *ngIf="getAssignmentDetail(operationCallRep)">
                    {{ getAssignmentDetail(operationCallRep) }}
                  </span>
                  <div class="assignment-pills" *ngIf="getAssignmentSourceLabel(operationCallRep)">
                    <span class="assignment-source">{{ getAssignmentSourceLabel(operationCallRep) }}</span>
                    <span class="assignment-lock" *ngIf="mode.edit && isInheritedOnlyAssignment(operationCallRep)">
                      Edit in Teams
                    </span>
                  </div>
                </div>
              </ng-template>
            </ion-item>
          </div>
          <div class="controls">
            <a *ngIf="mode.add || mode.edit" class="add-members" (click)="addAdditionalOperationCallRep()"
              >+ Care Rep</a
            >
          </div>
        </ion-list>
      </ng-container>
    </fieldset>
  </form>
</div>
